export default "__VITE_ASSET__B1ro3f_0__"